/**
 * Business rule: Invoice billing is only offered for orders of at least this
 * many screens. Enforced in `usePaymentShippingForm` (gates step-3 Continue) and
 * surfaced by `InvoiceNotice`. Single source so the copy and the validation can
 * never drift.
 */
export const INVOICE_MIN_SCREENS = 5;
